import React from "react";
import ReactDOM from "react-dom";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./index.scss";
import App from "./App";
import * as dotenv from "dotenv";
import reportWebVitals from "./reportWebVitals";
import { HomePage } from "views/HomePage";
import { PrivacyPolicy } from "views/barbu/PrivacyPolicy";
import { Support } from "views/barbu/Support/Support";

dotenv.config();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="" element={<HomePage />} />
          <Route path="barbu/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="barbu/contact-us" element={<Support />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
